import * as React from 'react';
import React__default from 'react';
import nextWithRedux from 'next-redux-wrapper';
import { initStore, useFeatureToggles } from '@grandvisionhq/state';
import NextApp from 'next/app';
import getConfig from 'next/config';
import { getToken } from '@grandvisionhq/auth';
import { initApolloClient, ApolloProvider } from '@grandvisionhq/graphql';
import { useBloomreachProductRoutes, CmsHeadTags, CmsContainerPage, CmsPageLayout, BloomreachProvider, parsePageModel, BloomreachApi } from '@grandvisionhq/bloomreach';
import { Context } from '@grandvisionhq/carts-v2';
import { getDisplayName as getDisplayName$1, LocaleUtils } from '@grandvisionhq/utils';
import { ErrorPage } from '@grandvisionhq/layout';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.
Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.
THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};
function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

var withRedux = function (App) {
    var Wrapper = /** @class */ (function (_super) {
        __extends(Wrapper, _super);
        function Wrapper() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Wrapper.getInitialProps = function (props) {
            return __awaiter(this, void 0, void 0, function () {
                var pageProps, _a, isServer, store;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            pageProps = {};
                            _b.label = 1;
                        case 1:
                            _b.trys.push([1, , 4, 7]);
                            if (!(typeof App.getInitialProps === 'function')) return [3 /*break*/, 3];
                            return [4 /*yield*/, App.getInitialProps(props)];
                        case 2:
                            pageProps = _b.sent();
                            _b.label = 3;
                        case 3: return [3 /*break*/, 7];
                        case 4:
                            _a = props.ctx, isServer = _a.isServer, store = _a.store;
                            if (!isServer) return [3 /*break*/, 6];
                            return [4 /*yield*/, store.close()];
                        case 5:
                            _b.sent();
                            _b.label = 6;
                        case 6: return [7 /*endfinally*/];
                        case 7: return [2 /*return*/, pageProps];
                    }
                });
            });
        };
        Wrapper.prototype.render = function () {
            return React.createElement(App, __assign({}, this.props));
        };
        return Wrapper;
    }(React.Component));
    return nextWithRedux(initStore)(Wrapper);
};

var publicRuntimeConfig = getConfig().publicRuntimeConfig;
var grandvision = publicRuntimeConfig.grandvision;
var graphQLUrl = grandvision.endpoints.graphql;
var getDisplayName = function (Component) {
    return Component.displayName || Component.name || 'Unknown';
};
var withApollo = function () { return function (PageComponent) {
    var WithApollo = function (_a) {
        var apolloClient = _a.apolloClient, apolloState = _a.apolloState, pageProps = __rest(_a, ["apolloClient", "apolloState"]);
        var client = apolloClient || initApolloClient(graphQLUrl, { initialState: apolloState, getToken: getToken });
        return (React__default.createElement(ApolloProvider, { client: client },
            React__default.createElement(PageComponent, __assign({}, pageProps))));
    };
    if (PageComponent.getInitialProps) {
        WithApollo.getInitialProps = function (ctx) { return __awaiter(void 0, void 0, void 0, function () {
            var inAppContext, apolloClient, pageProps, apolloState;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        inAppContext = Boolean(ctx === null || ctx === void 0 ? void 0 : ctx.ctx);
                        if (ctx.apolloClient) {
                            console.error('Multiple instances of withApollo found.');
                            throw new Error('Multiple instances of withApollo found.');
                        }
                        apolloClient = initApolloClient(graphQLUrl, { getToken: getToken });
                        // Add apolloClient to NextPageContext & NextAppContext
                        // This allows us to consume the apolloClient inside our
                        // custom `getInitialProps({ apolloClient })`.
                        ctx.apolloClient = apolloClient;
                        if (inAppContext) {
                            ctx.ctx.apolloClient = apolloClient;
                        }
                        pageProps = {};
                        if (!PageComponent.getInitialProps) return [3 /*break*/, 2];
                        return [4 /*yield*/, PageComponent.getInitialProps(ctx)];
                    case 1:
                        pageProps = _a.sent();
                        return [3 /*break*/, 4];
                    case 2:
                        if (!inAppContext) return [3 /*break*/, 4];
                        return [4 /*yield*/, NextApp.getInitialProps(ctx)];
                    case 3:
                        pageProps = _a.sent();
                        _a.label = 4;
                    case 4:
                        if (typeof window === 'undefined') {
                            // When redirecting, the response is finished.
                            // No point in continuing to render
                            if (ctx.res && (ctx.res.headersSent || ctx.res.finished)) {
                                return [2 /*return*/, pageProps];
                            }
                        }
                        apolloState = apolloClient.cache.extract();
                        return [2 /*return*/, __assign(__assign({}, pageProps), { apolloState: apolloState })];
                }
            });
        }); };
    }
    WithApollo.displayName = "WithApollo(" + getDisplayName(PageComponent) + ")";
    return WithApollo;
}; };

function withCart(settings) {
    var _this = this;
    return function (_a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.readOnly, readOnly = _c === void 0 ? false : _c;
        return function (PageComponent) {
            var displayName = getDisplayName$1(PageComponent);
            var WithCart = function (pageProps) {
                var _a = __read(useBloomreachProductRoutes(), 3); _a[0]; var formatProductUrl = _a[1].formatProductUrl, productRoutes = _a[2];
                var isCartV2Enabled = useFeatureToggles().isCartV2Enabled;
                var cartHash = pageProps.cartHash, cartId = pageProps.cartId;
                if (!isCartV2Enabled) {
                    return React.createElement(PageComponent, __assign({}, pageProps));
                }
                return (React.createElement(Context.CartSettingsProvider, { settings: __assign(__assign(__assign(__assign({}, settings), { formatProductUrl: formatProductUrl, productRoutes: productRoutes, readOnly: readOnly }), (cartHash ? { cartHash: cartHash } : undefined)), (cartId ? { cartId: cartId } : undefined)) },
                    React.createElement(Context.CartProvider, null, function (_a) {
                        var cart = _a.cart, refetch = _a.refetch;
                        return (React.createElement(PageComponent, __assign({}, pageProps, { cart: cart, refetchCart: refetch })));
                    })));
            };
            WithCart.getInitialProps = function (ctx) { return __awaiter(_this, void 0, void 0, function () {
                var _a, cartId, cartHash, pageProps;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _a = ctx.query || {}, cartId = _a.cartId, cartHash = _a.cartHash;
                            if (!(typeof PageComponent.getInitialProps === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, PageComponent.getInitialProps(ctx)];
                        case 1:
                            pageProps = _b.sent();
                            return [2 /*return*/, __assign(__assign({}, pageProps), { cartId: cartId, cartHash: cartHash })];
                        case 2: return [2 /*return*/, {
                                cartId: cartId,
                                cartHash: cartHash,
                            }];
                    }
                });
            }); };
            WithCart.displayName = "WithCart(" + displayName + ")";
            return WithCart;
        };
    };
}

var withErrorPage = function (PageComponent) {
    var WithErrorPage = function (props) {
        var buttonText = props.buttonText, image = props.image, statusCode = props.statusCode, subheader = props.subheader, title = props.title;
        if (statusCode && statusCode >= 400) {
            // If we receive a 404, we can assume that we still have a pagemodel, so we want to return the header and footer as well
            if (statusCode === 404) {
                return (React.createElement(React.Fragment, null,
                    React.createElement(CmsHeadTags, { title: title, noIndex: true, noFollow: true }),
                    React.createElement(CmsContainerPage, null,
                        React.createElement(CmsPageLayout, null,
                            React.createElement(ErrorPage, { header: title, buttonText: buttonText, image: image, subheader: subheader })))));
            }
            return (React.createElement(React.Fragment, null,
                React.createElement(CmsHeadTags, { title: title, noIndex: true, noFollow: true }),
                React.createElement(ErrorPage, { header: title, buttonText: buttonText, image: image, subheader: subheader })));
        }
        return React.createElement(PageComponent, __assign({}, props));
    };
    WithErrorPage.getInitialProps = function (ctx) { return __awaiter(void 0, void 0, void 0, function () {
        var pageProps, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!PageComponent.getInitialProps) return [3 /*break*/, 2];
                    return [4 /*yield*/, PageComponent.getInitialProps(ctx)];
                case 1:
                    _a = _b.sent();
                    return [3 /*break*/, 3];
                case 2:
                    _a = null;
                    _b.label = 3;
                case 3:
                    pageProps = (_a) || {};
                    if (pageProps.statusCode && ctx.res) {
                        ctx.res.statusCode = pageProps.statusCode;
                    }
                    return [2 /*return*/, pageProps];
            }
        });
    }); };
    WithErrorPage.displayName = "WithErrorPage(" + (PageComponent.displayName || PageComponent.name || 'Unknown') + ")";
    return WithErrorPage;
};

/**
 * Sets up the BloomreachProvider for any page and makes sure a pageModel is supplied.
 * This currently relies on our express servers to set the pageModel on the `res.locals` object.
 *
 * wrapInContainerPage: boolean Some pages are not container pages, like content and error pages
 *
 * @usage
 * First re-export from the opco site
 * const settings = {...}
 * export const withCms = withBloomreach(settings)
 *
 * const Page = () => {}
 * export default withCms()(Page)
 *
 * For non container pages
 * const Page = () => {}
 * export default withCms({ wrapInContainerPage: false })(Page)
 */
function withBloomreach(settings) {
    var _this = this;
    return function (_a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.wrapInContainerPage, wrapInContainerPage = _c === void 0 ? true : _c;
        return function (PageComponent) {
            var WithBloomreach = function (pageProps) {
                var pageModel = pageProps.pageModel, visitor = pageProps.visitor, path = pageProps.path, _a = pageProps.isMultilingualEnabled, isMultilingualEnabled = _a === void 0 ? false : _a, _b = pageProps.locale, locale = _b === void 0 ? settings.defaultLocale : _b;
                var contextSettings = __assign(__assign({}, settings.bloomreach), { isMultilingualEnabled: isMultilingualEnabled, locale: locale, visitor: visitor, pageModel: pageModel, path: path });
                var Wrapper = wrapInContainerPage ? CmsContainerPage : React__default.Fragment;
                return (React__default.createElement(BloomreachProvider, { settings: contextSettings },
                    React__default.createElement(Wrapper, null,
                        React__default.createElement(PageComponent, __assign({}, pageProps)))));
            };
            if (process.env.NODE_ENV !== 'production') {
                var displayName = PageComponent.displayName || PageComponent.name || 'Unknown';
                WithBloomreach.displayName = "WithBloomreach(" + displayName + ")";
            }
            WithBloomreach.getInitialProps = function (ctx) { return __awaiter(_this, void 0, void 0, function () {
                var req, res, query, _a, asPath, defaultLocale, isMultilingualEnabled, apiUrl, preview, locale, tasks, rehydratedPageModel, _b, _c, pageProps, page, pageModel, visitor;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0:
                            req = ctx.req, res = ctx.res, query = ctx.query, _a = ctx.asPath, asPath = _a === void 0 ? '' : _a;
                            defaultLocale = settings.defaultLocale, isMultilingualEnabled = settings.isMultilingualEnabled;
                            apiUrl = settings.bloomreach.apiUrl;
                            preview = isPreview(query);
                            locale = '';
                            if (isMultilingualEnabled()) {
                                // LocaleUtils expects the default Request type from express but we can't access that here
                                locale = Boolean(req)
                                    ? LocaleUtils.getLocale(req, defaultLocale, preview)
                                    : defaultLocale;
                            }
                            tasks = [null, null];
                            if (PageComponent.getInitialProps) {
                                tasks[0] = PageComponent.getInitialProps(ctx);
                            }
                            rehydratedPageModel = res === null || res === void 0 ? void 0 : res.locals.pageModel;
                            if (!rehydratedPageModel) {
                                tasks[1] = BloomreachApi.getPageModel(apiUrl, asPath, {
                                    locale: locale,
                                    headers: req === null || req === void 0 ? void 0 : req.headers,
                                    connection: req === null || req === void 0 ? void 0 : req.connection,
                                    isMultilingual: isMultilingualEnabled(),
                                });
                            }
                            return [4 /*yield*/, Promise.all(tasks)];
                        case 1:
                            _b = __read.apply(void 0, [_d.sent(), 2]), _c = _b[0], pageProps = _c === void 0 ? {} : _c, page = _b[1];
                            if (!rehydratedPageModel && !page) {
                                console.error("WithBloomreach: Failed to fetch page for " + asPath, page);
                            }
                            pageModel = parsePageModel(page);
                            visitor = res === null || res === void 0 ? void 0 : res.locals.visitor;
                            if (!visitor) {
                                visitor = page === null || page === void 0 ? void 0 : page.getVisitor();
                            }
                            return [2 /*return*/, __assign(__assign({}, pageProps), { visitor: visitor, locale: locale, path: asPath, isMultilingualEnabled: isMultilingualEnabled(), pageModel: rehydratedPageModel || pageModel })];
                    }
                });
            }); };
            return WithBloomreach;
        };
    };
}
function isPreview(query) {
    return query && typeof query.token === 'string';
}

/**
 * This HoC wraps a component in the CmsLayout rendering the header and footer with CMS content.
 * TODO: Ideally this shouldn't need to be a NextPage HoC but rather just a regular React HoC
 *  as it doesn't require getInitialProps, however we can only use it on NextPage level currently.
 *
 * Params:
 * settings - Some opcos require different settings for the header (my-account, cart-button etc)
 * layout - Some pages don't need to render all layout items, you can hide them with this object
 *
 * @usage
 * Re-export from opco:
 *  const settings = {...}
 *  export default withCmsLayout(settings)
 *
 * If you don't require additional settings, just export without passing settings:
 *  export default withCmsLayout()
 *
 * In a page component with default layout:
 *  const Page = () => {}
 *  export default withCmsLayout()(Page)
 *
 * If you need to change the layout settings:
 *  const Page = () => {}
 *  export default withCmsLayout({ header: false, navigation: false })(Page)
 */
function withCmsLayout(settings) {
    if (settings === void 0) { settings = {}; }
    return function (layout) {
        if (layout === void 0) { layout = {}; }
        return function (PageComponent) {
            var WithCmsLayout = function (props) {
                return (React__default.createElement(CmsPageLayout, __assign({}, settings, { layoutSettings: layout }),
                    React__default.createElement(PageComponent, __assign({}, props))));
            };
            // Forward getInitialProps
            if (typeof PageComponent.getInitialProps === 'function') {
                WithCmsLayout.getInitialProps = PageComponent.getInitialProps;
            }
            if (process.env.NODE_ENV !== 'production') {
                var displayName = PageComponent.displayName || PageComponent.name || 'Unknown';
                WithCmsLayout.displayName = "WithCmsLayout(" + displayName + ")";
            }
            return WithCmsLayout;
        };
    };
}

export { withApollo, withBloomreach, withCart, withCmsLayout, withErrorPage, withRedux };
//# sourceMappingURL=index.js.map
